const ActionType = {
    ACTION_TYPE_LIKE: 'ACTION_TYPE_LIKE',
    ACTION_TYPE_DISLIKE: 'ACTION_TYPE_DISLIKE',
};

export default ActionType;
